import { notFound } from 'next/navigation';

import { Aggregator, Place } from '@/types';
import { getChannel, getDocument, getPlaceId, replaceDynamicData } from '@lib/server';

export async function getSuccessPageData(domain: string, venue?: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) notFound();

  const { fields } = await getDocument<Aggregator>('aggregator', channel.micrositeData[0].id, {
    tags: [channel.channelId],
    depth: 0,
    select: [
      'fields.brandBookingSuccessHero',
      'fields.brandBookingSuccessPage',
      'fields.brandTicketSuccessHero',
      'fields.brandTicketSuccessPage',
      'fields.brandEnquirySuccessHero',
      'fields.brandEnquirySuccessPage',
      'fields.venueBookingSuccessHero',
      'fields.venueBookingSuccessPage',
      'fields.venueTicketSuccessHero',
      'fields.venueTicketSuccessPage',
      'fields.venueEnquirySuccessHero',
      'fields.venueEnquirySuccessPage',
    ],
  });

  const { placeId } = (venue && (await getPlaceId(channel, venue))) || {};
  const place =
    placeId &&
    (await getDocument<Place>('place', placeId, {
      tags: [channel.channelId],
      depth: 0,
      visibilityId: placeId,
      select: ['fields.default', 'fields.custom', 'fields.name', 'id'],
    }));

  const dynamicPlace =
    place &&
    replaceDynamicData({
      ...place.fields,
      successPage: {
        ticket: {
          heroBanner: fields?.venueTicketSuccessHero,
          page: fields?.venueTicketSuccessPage,
        },
        booking: {
          heroBanner: fields?.venueBookingSuccessHero,
          page: fields?.venueBookingSuccessPage,
        },
        enquiry: {
          heroBanner: fields?.venueEnquirySuccessHero,
          page: fields?.venueEnquirySuccessPage,
        },
      },
    });

  const venueData = dynamicPlace
    ? {
        ticket: dynamicPlace.successPage?.ticket,
        booking: dynamicPlace.successPage?.booking,
        enquiry: dynamicPlace.successPage?.enquiry,
      }
    : null;

  return {
    brand: fields && {
      ticket: {
        heroBanner: fields.brandTicketSuccessHero,
        page: fields.brandTicketSuccessPage,
      },
      booking: {
        heroBanner: fields.brandBookingSuccessHero,
        page: fields.brandBookingSuccessPage,
      },
      enquiry: {
        heroBanner: fields.brandEnquirySuccessHero,
        page: fields.brandEnquirySuccessPage,
      },
    },
    venue: venueData,
    transitionName: channel.themeConfig?.animations,
  };
}
